import React from 'react';
import { Link } from 'react-router-dom';
import { trustBadges, footerLinks, logo } from '../mockData';
import { Shield, Lock, Award, CheckCircle, FileText } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const getBadgeIcon = (badge) => {
    if (badge.includes('18+')) return <Shield className="w-5 h-5" />;
    if (badge.includes('SSL')) return <Lock className="w-5 h-5" />;
    if (badge.includes('Lizenziert')) return <Award className="w-5 h-5" />;
    if (badge.includes('Faire')) return <CheckCircle className="w-5 h-5" />;
    return <FileText className="w-5 h-5" />;
  };

  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 border-t border-cyan-500/20 text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-6xl mx-auto">
          {/* Brand */}
          <div className="flex items-center gap-8">
            <img src={logo} alt="Robocat Casino" className="h-16 w-auto flex-shrink-0" />
            <p className="text-sm text-gray-500 leading-relaxed">
              Robocat Casino ist Ihre vertrauenswürdige und unabhängige Quelle für umfassende Online-Casino-Bewertungen in Deutschland. Wir testen und analysieren Online-Casinos nach strengsten Kriterien, um deutschen Spielern fundierte Entscheidungen zu ermöglichen. Unsere Experten prüfen Spielauswahl, Bonusangebote, Zahlungsmethoden, Kundensupport und Sicherheitsstandards. Mit detaillierten Reviews, aktuellen Informationen und transparenten Bewertungen helfen wir Ihnen, das perfekte Online-Casino für Ihr Spielerlebnis zu finden.
            </p>
          </div>
        </div>
      </div>

      {/* Responsible Gaming Warning */}
      <div className="bg-gradient-to-r from-purple-900/30 via-fuchsia-900/30 to-purple-900/30 border-t border-purple-500/30">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center space-x-3">
              <Shield className="w-8 h-8 text-fuchsia-400" />
              <div className="text-sm">
                <p className="font-semibold text-fuchsia-400">18+ Spielen Sie verantwortungsbewusst</p>
                <p className="text-gray-400 text-xs mt-1">
                  Glücksspiel kann süchtig machen. Spielen Sie verantwortungsvoll und nur mit Geld, das Sie sich leisten können zu verlieren.
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4 text-xs text-gray-400">
              <a href="https://www.gamblingtherapy.org" target="_blank" rel="noopener noreferrer" className="hover:text-fuchsia-400 transition-colors">
                Gambling Therapy
              </a>
              <a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="hover:text-fuchsia-400 transition-colors">
                BeGambleAware
              </a>
              <a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer" className="hover:text-fuchsia-400 transition-colors">
                GamCare
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-slate-950 border-t border-slate-800">
        <div className="container mx-auto px-4 py-4 text-center text-sm text-gray-500">
          <p>&copy; {currentYear} Robocat Casino. Alle Rechte vorbehalten.</p>
          <p className="text-xs mt-2">
            Diese Website dient ausschließlich Informationszwecken. Wir sind kein Online-Casino, sondern eine unabhängige Bewertungsplattform.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
